import { defineMessages } from 'react-intl';

/**
 * Enum for fulfillment statuses.
 * @readonly
 * @enum {string}
 */
export const FulfillmentStatusEnum = {
  Rejected: 'Rejected',
  Unfulfillable: 'Unfulfillable',
  Exception: 'Exception',
  OnHold: 'OnHold',
  Cancelled: 'Cancelled',
  Empty: 'Empty',
  Received: 'Received',
  Invalid: 'Invalid',
  Planning: 'Planning',
  Processing: 'Processing',
  Complete: 'Complete',
  CompletePartialled: 'CompletePartialled',
  Shipped: 'Shipped',
};

export const messages = defineMessages({
  fulfillment3PLRejected: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Rejected',
    id: '1bzFhS',
  },
  fulfillment3PLEmpty: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Empty',
    id: 'QlDdCh',
  },
  fulfillment3PLReceived: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Received',
    id: '953x0g',
  },
  fulfillment3PLPlanning: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Planning',
    id: 'Y4l37q',
  },
  fulfillment3PLComplete: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Complete',
    id: 'sN6qSF',
  },
  fulfillment3PLProcessing: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Processing',
    id: 'xTWHvQ',
  },
  fulfillment3PLCompletePartialled: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Complete Partialled',
    id: 'RU2ZbC',
  },
  fulfillment3PLOnHold: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'On Hold',
    id: 'RxdHwx',
  },
  fulfillment3PLInvalid: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Invalid',
    id: '9L67e1',
  },
  fulfillment3PLException: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Exception',
    id: 'rY8bFy',
  },
  fulfillment3PLCancelled: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Cancelled',
    id: 'ah0Obc',
  },
  fulfillment3PLUnfulfillable: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Unfulfillable',
    id: 'iaOfzq',
  },
  fulfillment3PLShipped: {
    description: 'Orders Grid Column - Fulfillment Status - Informs user status of fulfillment through 3PL',
    defaultMessage: 'Shipped',
    id: '+h97NS',
  },
});

const statusToMessageDescriptorMap = {
  [FulfillmentStatusEnum.Rejected]: messages.fulfillment3PLRejected,
  [FulfillmentStatusEnum.Unfulfillable]: messages.fulfillment3PLUnfulfillable,
  [FulfillmentStatusEnum.Exception]: messages.fulfillment3PLException,
  [FulfillmentStatusEnum.OnHold]: messages.fulfillment3PLOnHold,
  [FulfillmentStatusEnum.Cancelled]: messages.fulfillment3PLCancelled,
  [FulfillmentStatusEnum.Empty]: messages.fulfillment3PLEmpty,
  [FulfillmentStatusEnum.Received]: messages.fulfillment3PLReceived,
  [FulfillmentStatusEnum.Invalid]: messages.fulfillment3PLInvalid,
  [FulfillmentStatusEnum.Planning]: messages.fulfillment3PLPlanning,
  [FulfillmentStatusEnum.Processing]: messages.fulfillment3PLProcessing,
  [FulfillmentStatusEnum.Complete]: messages.fulfillment3PLComplete,
  [FulfillmentStatusEnum.CompletePartialled]: messages.fulfillment3PLCompletePartialled,
  [FulfillmentStatusEnum.Shipped]: messages.fulfillment3PLShipped,
};

export const getMessageDescriptor = (fulfillmentStatus) => {
  const messageDescriptor = statusToMessageDescriptorMap[fulfillmentStatus];

  if (!messageDescriptor) {
    return;
  }

  return messageDescriptor;
};
